export default __webpack_public_path__ + "static/media/NumberFormats.test.js.41b00c7b.snap";